/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TriggerAutoCalcResponse
 */
export interface TriggerAutoCalcResponse {
    /**
     * 
     * @type {string}
     * @memberof TriggerAutoCalcResponse
     */
    jobId: string;
}

/**
 * Check if a given object implements the TriggerAutoCalcResponse interface.
 */
export function instanceOfTriggerAutoCalcResponse(value: object): value is TriggerAutoCalcResponse {
    if (!('jobId' in value) || value['jobId'] === undefined) return false;
    return true;
}

export function TriggerAutoCalcResponseFromJSON(json: any): TriggerAutoCalcResponse {
    return TriggerAutoCalcResponseFromJSONTyped(json, false);
}

export function TriggerAutoCalcResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriggerAutoCalcResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'jobId': json['jobId'],
    };
}

export function TriggerAutoCalcResponseToJSON(json: any): TriggerAutoCalcResponse {
    return TriggerAutoCalcResponseToJSONTyped(json, false);
}

export function TriggerAutoCalcResponseToJSONTyped(value?: TriggerAutoCalcResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'jobId': value['jobId'],
    };
}

